import { useLazyQuery, useMutation } from '@apollo/client/react';
import { useAtomValue } from 'jotai';
import { useEffect } from 'react';

import {
  GetCheckinUnreadOrganizationNotificationDocument,
  MarkOrganizationNotificationDocument,
} from '~/graphql/generated/graphql';
import { getNode } from '~/graphql/utility';
import { checkinEntryProfileDrawerState } from '~/state/reception/atoms';

export const useMarkNotification = () => {
  const { checkinEntryId } = useAtomValue(checkinEntryProfileDrawerState);
  const [markNotification] = useMutation(MarkOrganizationNotificationDocument);
  const [getNotifications, { data }] = useLazyQuery(
    GetCheckinUnreadOrganizationNotificationDocument,
    {
      fetchPolicy: 'network-only',
    },
  );

  useEffect(() => {
    if (!data) return;
    const notifications = getNode(data, 'CheckinEntry')?.unreadOrganizationNotifications || [];
    for (const notification of notifications) {
      markNotification({
        variables: {
          input: {
            organizationNotificationId: notification.id,
          },
        },
      });
    }
  }, [data, markNotification]);

  useEffect(() => {
    if (checkinEntryId) {
      getNotifications({
        variables: {
          checkinEntryId,
        },
      });
    }
  }, [checkinEntryId, getNotifications]);
};
